
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1711"}},[_c('path',{attrs:{"data-name":"Rectangle 2413","fill":"none","d":"M0 0h25v20H0z"}}),_c('path',{attrs:{"data-name":"Path 1062","d":"M23.5 8.5H22v-7a1.5 1.5 0 00-3 0v7h-5v-7a1.5 1.5 0 00-3 0v7H6v-7a1.5 1.5 0 00-3 0v7H1.5a1.5 1.5 0 000 3H3v3a5.492 5.492 0 009.5 3.763A5.492 5.492 0 0022 14.5v-3h1.5a1.5 1.5 0 000-3zM8.5 17A2.5 2.5 0 016 14.5v-3h5v3A2.5 2.5 0 018.5 17zM19 14.5a2.5 2.5 0 01-5 0v-3h5z","fill":"#3c3c3c"}})])])
          )
        }
      }
    